import React from 'react';

export default function Statements() {
  return (
    <>
      <h1 className="wp-portal__page-title">Statements</h1>
      <p className="wp-portal__page-sub">Royalty statements and payment history.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          No statements available. Your royalty statements will appear here once
          reporting periods have been completed.
        </p>
      </div>
    </>
  );
}
